import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EBetPositionStatus, reloadBetPosition } from '../../../../redux/reducers';
import {
  selectBetPosition,
  selectBetPositionClientError,
  selectBetPositionStatus,
} from '../../../../selectors/betPosition';
import { FatalError } from './components/FatalError';
import { Layout } from './components/Layout';
import { TDispatch } from '../../../../redux';
import { TBetPositionTheme } from './types';
import { numberToPrettyString } from '@cian/utils';
import { Position } from './components/Position';
import { LeadPosition } from './components/LeadPosition';
import { Loading } from './components/Loading';
import { NotFoundError } from './components/NotFoundError';

interface IBetPositionContainer {
  theme: TBetPositionTheme;
}

export const BetPositionContainer = ({ theme }: IBetPositionContainer) => {
  const betPosition = useSelector(selectBetPosition);
  const status = useSelector(selectBetPositionStatus);
  const clientError = useSelector(selectBetPositionClientError);

  const dispatch = useDispatch<TDispatch>();

  const handleReloadClick = React.useCallback(() => {
    dispatch(reloadBetPosition());
  }, [dispatch]);

  const { page = null, offerPosition = null } = betPosition || {};

  if (status === EBetPositionStatus.pending && (!page || !offerPosition)) {
    return (
      <Layout theme={theme}>
        <Loading />
      </Layout>
    );
  }

  if (status === EBetPositionStatus.fail) {
    return (
      <Layout theme={theme}>
        <FatalError theme={theme} onReloadClick={handleReloadClick} />
      </Layout>
    );
  }

  if (clientError || !offerPosition || !page) {
    return (
      <Layout theme={theme}>
        <NotFoundError />
      </Layout>
    );
  }

  if (offerPosition === 1) {
    return (
      <Layout theme={theme}>
        <LeadPosition />
      </Layout>
    );
  }

  return (
    <Layout theme={theme}>
      <Position pagePosition={numberToPrettyString(page)} offerPosition={numberToPrettyString(offerPosition)} />
    </Layout>
  );
};
